<script setup>
import { ref, watch, onMounted } from "vue";
import WrCrossIcon from "../atoms/icons/WrCrossIcon.vue";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";
const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
    required: true,
  },
  plan: {
    type: String,
    default: "",
  },
  page: {
    type: String,
    default: "",
  },
});

const initial = ref("");

if (props.page == "wordpress") {
  initial.value = "WP";
} else if (props.page == "laravel") {
  initial.value = "LV";
} else if (props.page == "mobile-apps") {
  initial.value = "MB";
} else {
  initial.value = "WR";
}

onMounted(() => {
  if (props?.plan) handlePricePlan(props?.plan);
});

const handlePricePlan = (newPlan) => {
  switch (newPlan) {
    case "720 /month":
      planName.value = `${initial.value}-Maintenance-Standard-Monthly (Billed monthly)`;
      planPrice.value = "$720";
      break;
    case "1080 /month":
      planName.value = `${initial.value}-Maintenance-Premium-Monthly (Billed monthly)`;
      planPrice.value = "$1080";
      break;
    case "1440 /month":
      planName.value = `${initial.value}-Maintenance-Enterprise-Monthly (Billed monthly)`;
      planPrice.value = "$1440";
      break;
    case "7920 /year":
      planName.value = `${initial.value}-Maintenance-Standard-Yearly (Billed yearly)`;
      planPrice.value = "$7920";
      break;
    case "11880 /year":
      planName.value = `${initial.value}-Maintenance-Premium-Yearly (Billed yearly)`;
      planPrice.value = "$11880";
      break;
    case "15840 /year":
      planName.value = `${initial.value}-Maintenance-Enterprise-Yearly (Billed yearly)`;
      planPrice.value = "$15840";
      break;
    case "720":
      planName.value = `${initial.value}-Maintenance-Standard-Monthly (Billed monthly)`;
      planPrice.value = "$720";
      break;
    case "1080":
      planName.value = `${initial.value}-Maintenance-Premium-Monthly (Billed monthly)`;
      planPrice.value = "$1080";
      break;
    case "1440":
      planName.value = `${initial.value}-Maintenance-Enterprise-Monthly (Billed monthly)`;
      planPrice.value = "$1440";
      break;
    case "7920":
      planName.value = `${initial.value}-Maintenance-Standard-Yearly (Billed yearly)`;
      planPrice.value = "$7920";
      break;
    case "11880":
      planName.value = `${initial.value}-Maintenance-Premium-Yearly (Billed yearly)`;
      planPrice.value = "$11880";
      break;
    case "15840":
      planName.value = `${initial.value}-Maintenance-Enterprise-Yearly (Billed yearly)`;
      planPrice.value = "$15840";
      break;
    case "49 /month":
      planName.value = `${initial.value}-Maintenance-Standard-Monthly (Billed monthly)`;
      planPrice.value = "$49";
      break;
    case "99 /month":
      planName.value = `${initial.value}-Maintenance-Premium-Monthly (Billed monthly)`;
      planPrice.value = "$99";
      break;
    case "149 /month":
      planName.value = `${initial.value}-Maintenance-Enterprise-Monthly (Billed monthly)`;
      planPrice.value = "$149";
      break;
    case "490 /year":
      planName.value = `${initial.value}-Maintenance-Standard-Yearly (Billed yearly)`;
      planPrice.value = "$490";
      break;
    case "990 /year":
      planName.value = `${initial.value}-Maintenance-Premium-Yearly (Billed yearly)`;
      planPrice.value = "$990";
      break;
    case "1490 /year":
      planName.value = `${initial.value}-Maintenance-Enterprise-Yearly (Billed yearly)`;
      planPrice.value = "$1490";
      break;
    case "49":
      planName.value = `${initial.value}-Maintenance-Standard-Monthly (Billed monthly)`;
      planPrice.value = "$49";
      break;
    case "99":
      planName.value = `${initial.value}-Maintenance-Premium-Monthly (Billed monthly)`;
      planPrice.value = "$99";
      break;
    case "149":
      planName.value = `${initial.value}-Maintenance-Enterprise-Monthly (Billed monthly)`;
      planPrice.value = "$149";
      break;
    case "490":
      planName.value = `${initial.value}-Maintenance-Standard-Yearly (Billed yearly)`;
      planPrice.value = "$490";
      break;
    case "990":
      planName.value = `${initial.value}-Maintenance-Premium-Yearly (Billed yearly)`;
      planPrice.value = "$990";
      break;
    case "1490":
      planName.value = `${initial.value}-Maintenance-Enterprise-Yearly (Billed yearly)`;
      planPrice.value = "$1490";
      break;
    case "wordpress":
      planName.value = "WordPress Installation Service (Billed one-time)";
      planPrice.value = "$29";
      break;
    default:
      planName.value = "wrong";
      planPrice.value = "wrong";
      break;
  }
};

watch(
  () => props.plan,
  (newPlan) => {
    handlePricePlan(newPlan);
  }
);

const emit = defineEmits(["close"]);
const visible = ref(props.isOpen);
const planName = ref("");
const planPrice = ref("");

watch(
  () => props.isOpen,
  (newVal) => {
    visible.value = newVal;
  }
);

watch(visible, (newVal) => {
  if (!newVal) {
    emit("close");
  }
});

const handleClose = () => {
  visible.value = false;
};

const formValues = ref({
  fullName: "",
  businessEmail: "",
  creditCard: "",
  month: "",
  year: "",
  cvv: "",
});

const errors = ref({
  fullName: "",
  businessEmail: "",
  creditCard: "",
  month: "",
  year: "",
  cvv: "",
});

const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})$/i;
const namePattern = /^[^a-zA-Z]*[a-zA-Z].*$/;
const cardPattern = /^\d{12,19}$/;
const monthPattern = /^(0[1-9]|1[0-2])$/;
const yearPattern = /^\d{2}$/;
const cvvPattern = /^\d{3,4}$/;

const sanitizeCreditCardInput = () => {
  let digits = formValues.value.creditCard.replace(/\D/g, "");
  digits = digits.substring(0, 19);
  formValues.value.creditCard = digits.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
};

const sanitizeMonthInput = computed(() => {
  formValues.value.month = formValues.value.month.replace(/\D/g, "").trim();
});

const sanitizeYearInput = computed(() => {
  formValues.value.year = formValues.value.year.replace(/\D/g, "").trim();
});

const sanitizeCVVInput = computed(() => {
  formValues.value.cvv = formValues.value.cvv.replace(/\D/g, "").trim();
});

const validateEmail = () => {
  errors.value.businessEmail = "";
  if (!formValues.value.businessEmail) {
    errors.value.businessEmail = "Email is required";
    return false;
  }
  if (!emailPattern.test(formValues.value.businessEmail.toLowerCase())) {
    errors.value.businessEmail = "Invalid email format";
    return false;
  }
  return true;
};

const validateName = () => {
  errors.value.fullName = "";
  const name = formValues.value.fullName?.trim() || "";
  if (!name) {
    errors.value.fullName = "Full name is required";
    return false;
  }
  if (!namePattern.test(name.toLowerCase())) {
    errors.value.fullName = "Invalid name format";
    return false;
  }
  return true;
};

const validateCard = () => {
  errors.value.creditCard = "";
  if (!formValues.value.creditCard) {
    errors.value.creditCard = "Card number is required";
    return false;
  }
  const digits = formValues.value.creditCard.replace(/\s+/g, "");
  if (!cardPattern.test(digits)) {
    errors.value.creditCard = "Card number must be 12–19 digits";
    return false;
  }
  return true;
};

const validateMonth = () => {
  errors.value.month = "";
  if (!formValues.value.month) {
    errors.value.month = "Month is required";
    return false;
  }
  const digits = formValues.value.month.replace(/\D/g, "");

  if (!monthPattern.test(digits)) {
    errors.value.month = "Invalid month";
    return false;
  }
  return true;
};

const validateYear = () => {
  errors.value.year = "";
  if (!formValues.value.year) {
    errors.value.year = "Year is required";
    return false;
  }
  const digits = formValues.value.year.replace(/\D/g, "");
  if (!yearPattern.test(digits)) {
    errors.value.year = "Invalid year";
    return false;
  }
  return true;
};

const validateCVV = () => {
  errors.value.cvv = "";
  if (!formValues.value.cvv) {
    errors.value.cvv = "CVV is required";
    return false;
  }
  const digits = formValues.value.cvv.replace(/\D/g, "");

  if (!cvvPattern.test(digits)) {
    errors.value.cvv = "Invalid CVV";
    return false;
  }
  return true;
};

const validateForm = () => {
  const validations = [
    validateName(),
    validateEmail(),
    validateCard(),
    validateMonth(),
    validateYear(),
    validateCVV(),
  ];

  return validations.every((valid) => valid);
};

const isLoading = ref(false);

const handlePaymentInfo = async () => {
  if (!validateForm()) {
    return;
  }
  isLoading.value = true;
  const payload = {
    is_recurring: true,
    is_paid: null,
    strip_response: null,
    recurring_duration: "monthly",
    payment: {
      currency: "USD",
      amount: planPrice.value.replace("$", ""),
      package: planName.value,
      description: planName.value,
      customer_id: null,
    },
    customer: {
      email: formValues.value.businessEmail,
      name: formValues.value.fullName,
    },
    card: {
      type: "card",
      card: {
        number: formValues.value.creditCard.replace(/\s+/g, ""),
        exp_month: formValues.value.month,
        exp_year: formValues.value.year,
        cvc: formValues.value.cvv,
      },
    },
    return_url: "https://webreinvent.com/wordpress",
  };

  try {
    const { data, error } = await useFetch(
      "https://api.webreinvent.com/api/pay/stripe/subscribe",
      {
        method: "POST",
        body: payload,
      }
    );
    if (error.value || !data.value) {
      toast.add({
        severity: "error",
        summary: "Validation Error",
        detail: 'Something went wrong, please try again later."',
        life: 5000,
      });
    } else {
      toast.add({
        severity: "success",
        summary: "Payment Successful",
        detail: "Your payment has been processed successfully.",
        life: 5000,
      });
      formValues.value = {
        fullName: "",
        businessEmail: "",
        creditCard: "",
        month: "",
        year: "",
        cvv: "",
      };
      emit("close");
    }
  } catch (err) {
    console.error("Unexpected Error:", err);
  } finally {
    isLoading.value = false;
  }
};
</script>

<template>
  <div class="card flex justify-center z-30">
    <Dialog
      v-model:visible="visible"
      :modal="true"
      :dismissableMask="true"
      closeOnEscape
      closable
      unstyled
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
      class="w-[90vw] md:w-[80vw] max-h-[90vh] bg-white"
      :pt="{
        root: {
          class:
            'relative dark:bg-[linear-gradient(92.4deg,_rgba(53,9,91)_6.22%,rgba(63,0,119)_93.78%)] bg-[#fff] rounded-xl p-4 md:p-7',
        },
        content: {
          class: 'max-h-[90vh] overflow-y-auto',
        },
        headerActions: {
          class: 'hidden',
        },
        mask: {
          class: 'bg-[hsla(0,_0%,_4%,_0.7)]',
        },
      }"
    >
      <template #header>
        <div class="absolute -top-3 -right-3 z-40">
          <button @click="handleClose">
            <WrCrossIcon
              class="text-white p-1 bg-[#5f4ca4] rounded-full border-2"
            />
          </button>
        </div>
      </template>
      <div class="overflow-hidden">
        <div class="">
          <h3
            class="font-bold text-2xl md:text-[30px] text-center leading-tight"
          >
            Before you check out, we want to say thank you.
          </h3>
          <p class="md:text-lg text-center mt-2">
            Let’s get you on a new plan that best meets your needs.
          </p>

          <div
            class="flex max-md:flex-col flex-items-center justify-between mt-7 gap-5 px-1"
          >
            <div class="flex flex-col items-start gap-5 w-full md:max-w-[60%]">
              <h4 class="font-bold text-[18px]">Payment Information</h4>
              <form
                class="dark:bg-transparent [background-color:#fff] [border-radius:10px] [box-shadow:0_.3em_.3em_-.3em_hsla(0,0%,4%,.1),_0_0_0_.1rem_hsla(0,0%,4%,_.08)] dark:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.5)] [max-width:100%] [position:relative] p-3 md:p-5"
              >
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div class="flex flex-col gap-1">
                    <InputText
                      v-model="formValues.fullName"
                      name="fullName"
                      type="text"
                      placeholder="Full Name"
                      class="w-full"
                      :class="{ 'p-invalid': errors.fullName }"
                      @blur="validateName"
                      @input="errors.fullName = ''"
                    />
                    <small v-if="errors.fullName" class="text-red-500">{{
                      errors.fullName
                    }}</small>
                  </div>

                  <div class="flex flex-col gap-1">
                    <InputText
                      v-model="formValues.businessEmail"
                      name="businessEmail"
                      type="email"
                      placeholder="Business Email"
                      class="w-full"
                      :class="{ 'p-invalid': errors.businessEmail }"
                      @blur="validateEmail"
                      @input="errors.businessEmail = ''"
                    />
                    <small v-if="errors.businessEmail" class="text-red-500">{{
                      errors.businessEmail
                    }}</small>
                  </div>

                  <div class="flex flex-col gap-1">
                    <InputText
                      v-model="formValues.creditCard"
                      name="creditCard"
                      type="tel"
                      placeholder="Credit Card"
                      class="w-full"
                      :class="{ 'p-invalid': errors.creditCard }"
                      @blur="validateCard"
                      @input="sanitizeCreditCardInput"
                      maxlength="23"
                    />
                    <small v-if="errors.creditCard" class="text-red-500">{{
                      errors.creditCard
                    }}</small>
                  </div>

                  <div class="grid grid-cols-3 gap-4">
                    <div class="flex flex-col gap-1">
                      <InputText
                        v-model="formValues.month"
                        name="month"
                        type="tel"
                        placeholder="MM"
                        class="w-full"
                        :class="{ 'p-invalid': errors.month }"
                        @blur="validateMonth"
                        @input="sanitizeMonthInput"
                        maxlength="2"
                      />
                      <small v-if="errors.month" class="text-red-500">{{
                        errors.month
                      }}</small>
                    </div>

                    <div class="flex flex-col gap-1">
                      <InputText
                        v-model="formValues.year"
                        name="year"
                        type="tel"
                        placeholder="YY"
                        class="w-full"
                        :class="{ 'p-invalid': errors.year }"
                        @blur="validateYear"
                        @input="sanitizeYearInput"
                        maxlength="2"
                      />
                      <small v-if="errors.year" class="text-red-500">{{
                        errors.year
                      }}</small>
                    </div>

                    <div class="flex flex-col gap-1">
                      <InputText
                        v-model="formValues.cvv"
                        name="cvv"
                        type="password"
                        placeholder="cvv"
                        class="w-full"
                        :class="{ 'p-invalid': errors.cvv }"
                        @blur="validateCVV"
                        @input="sanitizeCVVInput"
                        maxlength="4"
                      />
                      <small v-if="errors.cvv" class="text-red-500">{{
                        errors.cvv
                      }}</small>
                    </div>
                  </div>
                </div>
                <div class="mt-5 flex items-center justify-between w-full">
                  <p class="opacity-50 text-base font-medium">
                    Guaranteed <b>safe & secure</b> checkout
                  </p>

                  <NuxtImg
                    src="/images/powered-by-stripe-logo.webp"
                    height="28"
                    width="100"
                    loading="lazy"
                    format="webp"
                    alt="Powered by Stripe"
                  />
                </div>
              </form>

              <NuxtImg
                src="/images/stripe-payment-methods.webp"
                height="auto"
                width="528"
                loading="lazy"
                format="webp"
                alt="payment Methods"
              />
            </div>
            <div class="flex flex-col gap-5 items-start md:max-w-[40%] w-full">
              <h4 class="font-bold text-[18px]">Payment Summary</h4>
              <div
                class="max-md:w-full flex flex-col items-start bg-[#fff] dark:bg-transparent overflow-hidden [border-radius:10px] [box-shadow:0_.3em_.3em_-.3em_hsla(0,_0%,_4%,_.1),_0_0_0_.1rem_hsla(0,_0%,_4%,_.08)] dark:dark:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.5)] max-w-full relative"
              >
                <div
                  class="bg-[#eaf2fb] border border-[#eaf2fb] text-[#2d7ad2] [padding:1.25rem_2.5rem_1.25rem_1.5rem] relative w-full text-sm"
                  v-if="props?.plan?.includes('month')"
                >
                  <p>Get 1 month free with yearly billing</p>
                </div>
                <div class="pt-3 px-4 max-md:w-full">
                  <div
                    class="flex items-start justify-between w-full font-bold text-sm px-2"
                  >
                    <h4 class="max-w-[80%] w-full md:text-base">
                      {{ planName }}
                    </h4>
                    <p class="max-w-[10%] w-full">{{ planPrice }}</p>
                  </div>
                </div>
                <button
                  class="bg-[#5f4ca4] border-transparent text-white text-center px-[16px] py-[7px] bg-[linear-gradient(to_right_bottom,_#243ea1,_#283aa2,_#2d36a3,_#3231a3,_#372ca3,_#3f2ba4,_#462aa6,_#4d28a7,_#572baa,_#602eae,_#6932b1,_#7235b4)] mt-5 rounded-md font-medium w-full flex items-center justify-center gap-2"
                  @click="handlePaymentInfo()"
                  :disabled="isLoading"
                >
                  <span v-if="!isLoading">Proceed to Payment</span>
                  <span
                    v-else
                    class="inline-block border-2 border-white border-t-transparent rounded-full w-5 h-5 animate-spin"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
